import { marginPnodeZoneEffectieve } from 'api/pgads'
import React, { useMemo, useCallback, useContext } from 'react'
import R from 'ramda'
import { DatePickerContext, ErrorContext } from 'context'
import moment from 'moment'
import { emptyArray, empty } from 'core'
import { CPS_CLIENT } from '../client'

const PNodeZoneContext = React.createContext(null)

export const PNodeZoneContextProvider = ({
  children,
  targetInfo,
  units,
  unitNameMap,
  pnodeZoneList,
  setPNodeZoneList,
  CLIENT,
}) => {
  // const start = new Date()
  const { selectedDate } = useContext(DatePickerContext)
  const { setError, error } = useContext(ErrorContext)

  const loadPNodeZone = useCallback(
    _ => {
      if (targetInfo.jwt)
        marginPnodeZoneEffectieve(targetInfo).fork(
          err => {
            if (!R.equals(error, err)) setError(err)
          },
          data => {
            setPNodeZoneList(data)
          }
        )
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [targetInfo]
  )

  // useEffect(loadPNodeZone, [loadPNodeZone])

  const {
    marginUnitsList,
    unitIdEmktIdMap,
    getMarginUnitCode,
    marginUnitNameMap,
    emktUnitIdList,
    emktUnits,
  } = useMemo(() => {
    if (units == null || pnodeZoneList == null) return emptyArray
    const unitIds = units.map(u => u.unitId)

    const activePNodes = pnodeZoneList
      .filter(u => unitIds.includes(u.unitId))
      .filter(
        m =>
          m.retired === 0 ||
          m.retired === '0' ||
          // query already says margin-pnode-zone-effective not sure why we still have to apply effective logic here
          // unless api is returning all pnodes
          moment(m.effectivedate, 'YYYY-MM-DD').isBefore(selectedDate) ||
          moment(m.effectivedate, 'YYYY-MM-DD').isSame(selectedDate)
      )
    // .map(m => m.unitId)
    const emktPNodeZone = activePNodes.filter(e => e.emktid != null)

    const emktUnitIdList = emktPNodeZone.map(e => e.unitId)

    const emktUnits = units.filter(u => emktUnitIdList.includes(u.unitId))

    const unitIdEmktIdMapMain = R.compose(
      R.fromPairs,
      R.chain(z =>
        z.rollupEmktid != null
          ? [
              [z.utility + z.rollupEmktid, z.rollupEmktid],
              [z.unitId, z.emktid],
            ]
          : [[z.unitId, z.emktid]]
      )
    )(emktPNodeZone)

    const unitIdEmktIdMapCCType = R.compose(
      R.fromPairs,
      R.unnest,
      R.map(em => [
        [em + 'X2', em + 'X2'],
        [em + 'X3', em + 'X3'],
      ]),
      R.map(u => unitIdEmktIdMapMain[u.unitId]),
      R.filter(f => f.id1 === 'CC')
    )(emktUnits)

    const isRequiredCCX2X3 = CLIENT === CPS_CLIENT

    const unitIdEmktIdMap = isRequiredCCX2X3
      ? { ...unitIdEmktIdMapMain, ...unitIdEmktIdMapCCType }
      : unitIdEmktIdMapMain

    const rollupUnitIds = activePNodes
      .filter(f => f.rollupEmktid != null)
      .map(rr => rr.unitId)

    const marginUnits = emktUnits.filter(u => !rollupUnitIds.includes(u.unitId))

    const unitMap = R.compose(
      R.fromPairs,
      R.map(u => [u.unitId, u])
    )(units)

    const rollupUnits = activePNodes
      .filter(f => f.rollupEmktid != null)
      .map(z =>
        unitMap[z.unitId] == null
          ? null
          : { ...unitMap[z.unitId], rollupEmktid: z.rollupEmktid }
      )

    const marginUnitsList = R.compose(
      R.sortWith([R.ascend(R.prop('unitName'))]),
      R.uniqBy(u => u.unitId)
    )([
      ...marginUnits,
      ...rollupUnits
        // .filter(r => !!r)
        .map(u => ({
          unitId: '' + u.utility + u.rollupEmktid,
          utility: u.utility,
          unit: '000',
          unitName: u.rollupEmktid,
          rollupEmktid: u.rollupEmktid,
          emktId: u.rollupEmktid,
          // emktId: '000',
          utilityRollupId: '' + u.utility + u.rollupEmktid,
        })),
    ])
    // const getMarginUnitCode = unitId =>
    //   marginUnitsList.find(u => u.unitId === unitId)
    const getMarginUnitCode = unitId => {
      const nu = marginUnitsList.find(u => u.unitId === unitId)
      return (nu || {}).unit
    }

    const rollUnitNameMap = R.compose(
      R.fromPairs,
      R.map(u => [u.unitId, u.rollupEmktid]),
      R.filter(m => m.utilityRollupId)
    )(marginUnitsList)
    const marginUnitNameMap = { ...unitNameMap, ...rollUnitNameMap }
    return {
      marginUnitsList,
      emktUnits,
      emktUnitIdList,
      unitIdEmktIdMap,
      getMarginUnitCode,
      marginUnitNameMap,
    }
  }, [CLIENT, pnodeZoneList, selectedDate, unitNameMap, units])

  // const avaliableUnitId = useCallback(
  //   // eslint-disable-next-line no-unused-vars
  //   (hideHDPSunitType = false) => {
  //     const ids = units.map(u => u.unitId)

  //     // RKhan do not wants to add below condition
  //     // bocz might be some user used HD for MArgin analysis and
  //     // in that condtion they have link it in oa-ma-pnode-zone
  //     // else they dont put data in oa_ma_pnode_zone
  //     // if (hideHDPSunitType)
  //     //   ids = units
  //     //     .filter(u => u.id1 !== 'HD' && u.id1 !== 'PS')
  //     //     .map(u => u.unitId)

  //     const effPnodeId = (pnodeZoneList || [])
  //       .filter(u => ids.includes(u.unitId))
  //       .filter(
  //         m =>
  //           m.retired === 0 ||
  //           m.retired === '0' ||
  //           moment(m.effectivedate, 'YYYY-MM-DD').isBefore(selectedDate) ||
  //           moment(m.effectivedate, 'YYYY-MM-DD').isSame(selectedDate)
  //       )
  //       .map(m => m.unitId)
  //     // return ids.filter(i=>effPnodeId.includes(i))
  //     // return R.intersection(ids, effPnodeId)
  //     return effPnodeId
  //   },
  //   [units, pnodeZoneList, selectedDate]
  // )

  // const emktUnitIdList = useMemo(
  //   _ =>
  //     (pnodeZoneList || [])
  //       .filter(e => e.emktid)
  //       .filter(u => avaliableUnitId().includes(u.unitId))
  //       .map(u => u.unitId),
  //   [pnodeZoneList, avaliableUnitId]
  // )

  // const emktUnits = useMemo(
  //   _ => units.filter(u => emktUnitIdList.includes(u.unitId)),
  //   [emktUnitIdList, units]
  // )

  const [pnodeUnitIdList, emktIdUnitIdMap] = useMemo(
    _ =>
      pnodeZoneList == null
        ? [emptyArray, empty]
        : [
            pnodeZoneList
              .filter(e => e.pnodeid)
              .filter(e => e.pnodeid !== '#N/A')
              .map(u => u.unitId),
            R.compose(
              R.fromPairs,
              R.map(u => [u.emktid, u.unitId]),
              R.filter(u => u.emktid)
            )(pnodeZoneList),
          ],
    [pnodeZoneList]
  )

  // const emktIdUnitIdMap = useMemo(
  //   _ => {

  //     return emktMap
  //   },
  //   [pnodeZoneList]
  // )

  // const unitIdEmktIdMap = useMemo(
  //   _ => {
  //     const emktMap = R.compose(
  //       R.fromPairs,
  //       R.map(u => [u.unitId, u.emktid]),
  //       R.filter(u => u.emktid)
  //     )(pnodeZoneList || [])

  //     const rollupEmktMap = R.compose(
  //       R.fromPairs,
  //       R.map(u => ['' + u.utility + u.rollupEmktid, u.rollupEmktid]),
  //       R.filter(u => avaliableUnitId().includes(u.unitId)),
  //       R.filter(u => u.rollupEmktid)
  //     )(pnodeZoneList || [])

  //     return { ...emktMap, ...rollupEmktMap }
  //   },
  //   [avaliableUnitId, pnodeZoneList]
  // )

  const [emktIdUnitNameMap, pnodeIdUnitNameMap] = useMemo(() => {
    if (pnodeZoneList == null) return [{}, {}]

    // const unitNameMap = R.compose(
    //   R.fromPairs,
    //   R.map(u => [u.unitId, u.unitName])
    // )(units)

    const emktIdUnitNameMap = R.compose(
      R.fromPairs,
      R.map(u => [u.emktid, unitNameMap[u.unitId] ?? u.unitId]),
      R.filter(u => u.emktid)
    )(pnodeZoneList)

    const pnodeIdUnitNameMap = R.compose(
      R.fromPairs,
      R.map(u => [u.pnodeid, unitNameMap[u.unitId] ?? u.unitId]),
      R.filter(e => e.pnodeid !== '#N/A'),
      R.filter(u => u.pnodeid)
    )(pnodeZoneList || [])
    return [emktIdUnitNameMap, pnodeIdUnitNameMap]
  }, [pnodeZoneList, unitNameMap])

  // const emktIdUnitNameMap = useMemo(
  //   _ =>
  //     R.compose(
  //       R.fromPairs,
  //       R.map(u => [
  //         u.emktid,
  //         (units.find(un => un.unitId === u.unitId) || {}).unitName || u.unitId,
  //       ]),
  //       R.filter(u => u.emktid)
  //     )(pnodeZoneList || []),
  //   [pnodeZoneList, units]
  // )

  // const pnodeIdUnitNameMap = useMemo(
  //   _ => {
  //     const pnodeMap = R.compose(
  //       R.fromPairs,
  //       R.map(u => [
  //         u.pnodeid,
  //         (units.find(un => un.unitId === u.unitId) || {}).unitName || u.unitId,
  //       ]),
  //       R.filter(e => e.pnodeid !== '#N/A'),
  //       R.filter(u => u.pnodeid)
  //     )(pnodeZoneList || [])

  //     return pnodeMap
  //   },
  //   [pnodeZoneList, units]
  // )

  // const marginUnitsList = useMemo(
  //   _ => {
  //     // pnodeZoneList.filter(f=>!f.rollupEmktid).filter(f=>f.emktid).map(e=>e.unitId)

  //     const rollupUnitIds = (pnodeZoneList || [])
  //       .filter(f => f.rollupEmktid)
  //       .filter(f => avaliableUnitId(true).includes(f.unitId))
  //       .map(rr => rr.unitId)

  //     const marginUnits = emktUnits.filter(
  //       u => !rollupUnitIds.includes(u.unitId)
  //     )

  //     const rollupUnits = (pnodeZoneList || [])
  //       .filter(f => f.rollupEmktid)
  //       .filter(f => avaliableUnitId(true).includes(f.unitId))
  //       .map(e => ({
  //         ...units.find(u => u.unitId === e.unitId),
  //         rollupEmktid: e.rollupEmktid,
  //       }))
  //     // .filter(r => !!r)

  //     let finalUnits = [
  //       ...marginUnits,
  //       ...rollupUnits
  //         // .filter(r => !!r)
  //         .map(u => ({
  //           unitId: '' + u.utility + u.rollupEmktid,
  //           utility: u.utility,
  //           unit: '000',
  //           unitName: u.rollupEmktid,
  //           rollupEmktid: u.rollupEmktid,
  //           emktId: u.rollupEmktid,
  //           // emktId: '000',
  //           utilityRollupId: '' + u.utility + u.rollupEmktid,
  //         })),
  //     ]

  //     finalUnits = R.uniqBy(u => u.unitId, finalUnits)

  //     const sortData = R.sortWith([
  //       // R.toLower,
  //       // R.descend,
  //       // R.toLower,
  //       // R.map(t => unitNameMap[t.unitId]),
  //       R.ascend(R.prop('unitName')),
  //     ])(finalUnits)

  //     return sortData
  //   },
  //   [avaliableUnitId, emktUnits, pnodeZoneList, units]
  // )

  // const getMarginUnitCode = unitId => {
  //   const nu = marginUnitsList.find(u => u.unitId === unitId)
  //   return nu.unit
  // }

  // const marginUnitNameMap = useMemo(
  //   _ => {
  //     const rollUnitNameMap = R.compose(
  //       R.fromPairs,
  //       R.map(u => [u.unitId, u.rollupEmktid]),
  //       R.filter(m => m.utilityRollupId)
  //     )(marginUnitsList)

  //     return { ...unitNameMap, ...rollUnitNameMap }
  //   },
  //   [marginUnitsList, unitNameMap]
  // )

  return (
    <PNodeZoneContext.Provider
      value={{
        loadPNodeZone,
        pnodeZoneList,
        emktUnitIdList,
        pnodeUnitIdList,
        emktIdUnitIdMap,
        emktUnits,
        unitIdEmktIdMap,
        emktIdUnitNameMap,
        pnodeIdUnitNameMap,
        marginUnitsList,
        getMarginUnitCode,
        marginUnitNameMap,
      }}
    >
      {children}
    </PNodeZoneContext.Provider>
  )
}

export default PNodeZoneContext
